
<template>
  <div>

    <b-dropdown split text="Novo" class="m-2" variant="primary" @click="addNew">
      <template #button-content>
        <feather-icon
          icon="PlusIcon"
          class="mr-50"
        />
        <span class="align-middle">{{$t('AddNew')}}</span>
      </template>
      <b-dropdown-item @click="showImportModal=!showImportModal">Importar</b-dropdown-item>
    </b-dropdown>

    <Grid :css_formats="gridCssFormats()" :service="service" route_name="legal_entities">
      <template #gridThead="thead">
        <vs-th
          v-for="(column, key) in thead.data"
          :key="key"
          :sort-key="thead.methods.getColumnSortKey(key)"
          sort-status="asc"
          >{{ $t(thead.methods.getColumnName(column)) }}</vs-th
        >
      </template>
      <template #gridData="gridData">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in gridData.data">
          <vs-td
            :data="gridData.data[indextr].id"
            v-for="(column, key) in gridData.columns"
            :key="key"
          >
            <div
              :class="
                gridData.methods.getColumnCss(gridData.data[indextr], key)
              "
            >
              <div
                :key="key"
                v-html-safe="
                  `<div>${gridData.methods.getColumnData(
                    gridData.data[indextr],
                    key
                  )}</div>`
                "
              />
            </div>
          </vs-td>
          <vs-td>
            <div class="flex flex-row gap-1">
              <feather-icon
                v-if="isHeadquarters(gridData.data[indextr])"
                icon="HomeIcon"
                class="hover:text-primary rounded text-dark h-5 w-5 stroke-current"
                @click="openLegalUnits(gridData.data[indextr])"
              />
              <feather-icon
                v-permission="`legal_entities.edit`"
                icon="EditIcon"
                class="h-5 w-5 stroke-current text-warning"
                v-if="!hide_edit"
                @click="gridData.edit(gridData.data[indextr].id)"
              />
              <feather-icon
                v-permission="`legal_entities.delete`"
                icon="Trash2Icon"
                class="h-5 w-5 stroke-current text-danger"
                v-if="!hide_delete"
                @click="confirmDestroy(gridData.data[indextr], gridData.fetchGridData)"
              />
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>

    <legal-units-popup ref="units_popup"/>

    <vs-popup title="Importar Pessoa Jurídica" :active.sync="showImportModal">
      <ImportExcel
        :onSuccess="onSuccess"

        templateMessage="Clique aqui para baixar um modelo para <br/> o preenchimento de importação de pessoa jurídica."
        accept=".xlsx, .xls">
      </ImportExcel>
    </vs-popup>
  </div>
</template>


<script>
import { BButton, BDropdown, BDropdownItem } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import LegalEntityService from '@/services/api/LegalEntityService'
import ImportExcel from '@/components/excel/ImportExcel'
import LegalUnitsPopup from './LegalUnitsPopup.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BDropdown,
    BDropdownItem,
    ImportExcel,
    LegalUnitsPopup,
  },
  data: () => ({
    selected: [],
    service: null,
    showImportModal: false,
    sheetUploadUrl: ''
  }),
  computed: {
    importExampleUrl() {
      return `${process.env.VUE_APP_API_BASE_URL}/storage/templates/sca-modelo-importacao-pessoa-juridica.xlsx`
    },
  },
  methods: {
    gridCssFormats() {
      return {
        company_name: (columnData, rawData) => {
          return 'flex flex-row'
        }
      }
    },
    isHeadquarters(data) {
      const legalUnits = this._.get(data, 'legal_units', [])
      return this._.isArray(legalUnits) && legalUnits.length > 0
    },
    openLegalUnits(legalEntity) {
      this.$refs['units_popup'].open(legalEntity)
    },
    addNew() {
      this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', null)
      this.$router.push('/people/legal_entities/create')
    },
    onSuccess(data) {

      this.service.importLegalEntities(data).then(
        data => {
          this.notifySuccess(this.$vs, 'Importação realizada com sucesso.')
          this.showImportModal = false
        },
        error => {
          this.$vs.loading.close()
          this.showErrors(this.$refs.requestForm, error)
        }
      )
    },
    confirmDestroy(legalEntity, fetchGridData) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirmação',
        acceptText: 'Sim, excluir',
        cancelText: 'Cancelar',
        text: 'Tem certeza que deseja excluir esta Pessoa Jurídica? Esta ação é irreversível e não será possível recuperar os dados relacionados.',
        accept: () => {
          this.$vs.loading()
          this.service.destroy(legalEntity.id).then(
            () => {
              this.$vs.loading.close()
              this.notifySuccess(this.$vs)
              fetchGridData()
            },
            () => {
              this.$vs.loading.close()
            }
          )
        }
      })
    },
  },
  beforeMount() {
    this.service = LegalEntityService.build(this.$vs)
  },
}
</script>
